import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';

import '../../../css/TableSelector.css'; //

function TableSelector({ resultsTable, selectedTable, setSelectedTable, onSubmit }) {
  return (
    <Form onSubmit={onSubmit} className="table-selector-form">
      <Row className="justify-content-center">
        <Col md={4}>
          <Form.Group controlId="tableSelect" className="mb-4">
            <Form.Label><strong>Seleziona una tabella</strong></Form.Label>
            <Form.Select 
              value={selectedTable} 
              onChange={(e) => setSelectedTable(e.target.value)}
              className="custom-select"
            >
              <option value="">-- Scegli una tabella --</option>
              {resultsTable.map(item => (
                <option key={item.name} value={item.name}>{item.name}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <div className="text-center">
            <Button 
              type="submit" 
              className="read-table-btn"
              disabled={!selectedTable}
            >
              LEGGI TABELLA
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
}

export default TableSelector;
